import { RoutePerson } from "../@types/routes";
import { SCREENS } from "../consts/screens";

export const getAddressLocatorRoute = (routeId: string, addressId: string) => {
  return SCREENS.ADDRESS_LOCATOR.replace(':routeId', routeId).replace(':addressId', addressId);
};

export const getEditAddressRoute = (addressId: string) => {
  return SCREENS.EDIT_ADDRESS.replace(':addressId', addressId);
};

export const getPersonName = (person?: RoutePerson | null): string => {
  if (!person) {
    return '';
  }

  if (person.isLegacy) {
    return person.legacyName || '';
  }

  return `${person.firstName || ''} ${person.lastName || ''}`.trim();
};

export const getPersonFirstName = (person?: RoutePerson | null): string => {
  if (!person) {
    return '';
  }

  if (person.isLegacy) {
    return person.legacyName || '';
  }

  return person.firstName || '';
};

export const getRoutePeople = (
  driver?: RoutePerson | null,
  passengers?: RoutePerson[],
) => {
  let people = '';

  const driverName = getPersonFirstName(driver);
  if (driverName) {
    people = driverName;
  }

  if (passengers && passengers.length > 0) {
    const passengersText = passengers.map(getPersonFirstName).filter(Boolean).join(', ');

    if (passengersText) {
      if (people) {
        people += ' + ';
      }

      people += passengersText;
    }
  }

  return people;
};

export const getDefaultRouteRoute = (routeId: string) => {
  return SCREENS.DEFAULT_ROUTE.replace(':routeId', routeId);
};
